'use client'

import Carousel from '@components/common/Carousel/Carousel'
import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'
import UILink from '@components/ui/UILink'
import UIImage from '@components/ui/UIImage'
import { usePathname, useSearchParams } from 'next/navigation'
import { useQuery } from '@tanstack/react-query'
import { queryArticleBanner } from '@services/api/Article/Banner'
import { useLayoutEffect, useState } from 'react'
import { BannerVo } from '@schemas/non-auth'
import { uuidv4 } from '@utils/random'

const ArticleBanner = () => {
	const pathname = usePathname()
	const param = useSearchParams()
	const [bannerList, setBannerList] = useState<Array<BannerVo> | null>(null)
	const isPrevBanner = pathname.includes('articleBanner')
	const previewBannerIdx = param.get('previewBannerIdx')
	const { data: resBanner } = useQuery(
		queryArticleBanner({
			previewBannerIdx: isPrevBanner && !!previewBannerIdx ? previewBannerIdx : undefined,
		}),
	)
	useLayoutEffect(() => {
		if (resBanner?.data) {
			setBannerList(resBanner.data)
		}
	}, [resBanner])

	return (
		bannerList &&
		bannerList.length > 0 && (
			<Box
				className="print-hide"
				mx={{ xs: pxToRem(-20), md: 0 }}
				sx={{
					'.swiper-button-next': {
						right: 0,
					},
					'.swiper-button-prev': {
						left: 0,
					},
				}}
			>
				<Carousel
					pagination={bannerList.length > 1}
					navigation
					slidesPerView={1}
					breakpoints={{
						768: {
							spaceBetween: 16,
						},
						1024: {
							spaceBetween: 16,
						},
					}}
				>
					{bannerList?.map((bannerInfo) => (
						<Box
							px={{ xs: pxToRem(20), md: 0 }}
							key={`banner-${bannerInfo.bannerIdx}-${uuidv4()}`}
						>
							<Box
								overflow="hidden"
								borderRadius={pxToRem(8)}
								display={{ xs: 'none', md: 'block', lg: 'block' }}
								{...{ component: UILink, link: bannerInfo.pcLinkUrlInfo }}
								height={pxToRem(100)}
							>
								<UIImage
									src={bannerInfo.pcThumbnailImgUrl}
									alt={bannerInfo.bannerTitle}
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										objectPosition: 'center',
									}}
								/>
							</Box>
							<Box
								overflow="hidden"
								borderRadius={pxToRem(8)}
								display={{ xs: 'block', md: 'none', lg: 'none' }}
								{...{ component: UILink, link: bannerInfo.moLinkUrlInfo }}
								height={pxToRem(100)}
							>
								<UIImage
									src={bannerInfo.moThumbnailImgUrl}
									alt={bannerInfo.bannerTitle}
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'cover',
										objectPosition: 'center',
									}}
								/>
							</Box>
						</Box>
					))}
				</Carousel>
			</Box>
		)
	)
}

export default ArticleBanner
